import projectConfig from '../../../config';

const appCfg = {
  domik: projectConfig.apiKeys.fbDomikAppId,
  bild: projectConfig.apiKeys.fbBildAppId,
};

const fbAsyncInit = (project) => {
  if (__CLIENT__) {
    window.fbAsyncInit = () => (
      FB.init({ // eslint-disable-line
        appId: appCfg[project],
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v3.1'
      })
    );
  }
};

const fbShare = (href) => FB.ui({ // eslint-disable-line
  method: 'share',
  mobile_iframe: true,
  href,
});

export {
  fbAsyncInit,
  fbShare
};
